import { useCallback, useMemo } from 'react';

import type { ScheduleCadence, SimulationRun } from '@/modules/simulations/types';
import { cronToCadence } from '@/modules/simulations/utils';

import useSchedules from './useSchedules';

const useRunsCadence = (brainId?: string) => {
  const { schedules } = useSchedules(brainId);

  const cadenceByScheduleId = useMemo(() => {
    const map = new Map<string, ScheduleCadence>();
    (schedules ?? []).forEach((s) => {
      const cadence = cronToCadence(s.cron_expression);
      if (cadence) {
        map.set(s.schedule_id, cadence);
      }
    });
    return map;
  }, [schedules]);

  const getCadence = useCallback(
    (run: SimulationRun): ScheduleCadence | undefined => {
      if (run.trigger_type !== 'scheduled' || !run.schedule_id) {
        return undefined;
      }
      return cadenceByScheduleId.get(run.schedule_id);
    },
    [cadenceByScheduleId]
  );

  return { getCadence };
};

export default useRunsCadence;
